import styled from 'styled-components';

const ImageStyle = styled.div`
	--proportion: 50%;

	transition: var(--trTime) ease-out;

	&.image-cont {
		position: relative;
		padding-top: var(--proportion);

		img {
			object-fit: cover;
			object-position: center;
			transition: 0.6s ease-out;
		}
	}

	&.contain {
		img {
			object-fit: contain;
		}
	}
`;

export default ImageStyle;
